/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _isFunction from 'lodash/isFunction'
import { Action } from 'redux-app/types/actions'

export const createReducer = (initialState, handlers) => {
  return function reducer (state = initialState, action) {
    return handlers.hasOwnProperty(action.type) ? handlers[action.type](state, action) : state
  }
}

export const promiseTypeSuffixes = ['PENDING', 'FULFILLED', 'REJECTED']

export const handlePromiseActions = (reducerMap, initialState) => {
  const flatMap = {}

  Object.keys(reducerMap).forEach(actionType => {
    const reducerValue = reducerMap[actionType]

    if (Array.isArray(reducerValue)) {
      reducerValue.slice(0, promiseTypeSuffixes.length).forEach((promiseActionReducer, promiseTypeSuffixIndex) => {
        if (!_isFunction(promiseActionReducer)) {
          return
        }
        flatMap[`${actionType}_${promiseTypeSuffixes[promiseTypeSuffixIndex]}`] = promiseActionReducer
      })
    } else {
      flatMap[actionType] = reducerValue
    }
  })

  return createReducer(initialState, flatMap)
}

const defaultActionCreator = (type: string): Action => (payload?: any, meta: any = {}) => ({ type, payload, meta })

export const createModuleAction = (module: string) => (name: string, actionCreator?: Action) => {
  const finalName = `${module}/${name}`
  let currentActionCreator = actionCreator
  if (!currentActionCreator) {
    currentActionCreator = defaultActionCreator(finalName)
  }
  const result: any = (...params) => {
    const action: any = currentActionCreator(...params)
    action.type = finalName
    return action
  }
  result.toString = () => finalName
  return result
}
